enum IntegrationInstanceType {
  Sandbox = 1,
  Prod = 2,
}

export { IntegrationInstanceType };
